import React from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

// import { FaDownload } from 'react-icons/fa';
import { GrDocumentPdf } from 'react-icons/gr';
import { translate } from 'react-i18next';
const range = (start, end) => {
  return Array(end - start)
    .join(0)
    .split(0)
    .map(function (val, id) {
      return id + start;
    });
};

const PrintButton = ({ id, t }) => (
  <div className="tc mb4 mt2">
    <div id="myMm" style={{ height: '1mm' }} />

    <div
      className="text-white cursor-pointer"
      onClick={() => {
        const input = document.getElementById(id);
        input.style.cssText = 'display: block; margin-top: 1000px !important;';
        const HTML_Width = input.clientWidth;
        const HTML_Height = input.clientHeight;
        const top_left_margin = 15;
        const PDF_Width = HTML_Width + top_left_margin * 2;
        const PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
        const canvas_image_width = HTML_Width;
        const canvas_image_height = HTML_Height;

        const totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

        html2canvas(input, { allowTaint: true }).then((canvas) => {
          // canvas.getContext('2d');

          console.log(canvas.height, canvas.width);

          let imgData = canvas.toDataURL('image/jpeg');
          let pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height]);
          pdf.addImage(
            imgData,
            'JPG',
            top_left_margin,
            top_left_margin,
            canvas_image_width,
            canvas_image_height
          );

          for (let i = 1; i <= totalPDFPages; i++) {
            pdf.addPage([PDF_Width, PDF_Height]);
            pdf.addImage(
              imgData,
              'JPG',
              top_left_margin,
              -(PDF_Height * i) + top_left_margin * 4,
              canvas_image_width,
              canvas_image_height
            );
          }

          pdf.save(`${id}.pdf`);
          input.style.display = 'none';
        });
      }}
    >
      <GrDocumentPdf className="fz-12 mr-2 color-lightning" />
      {/**
      <FaDownload className="fz-12 mr-2 color-lightning" />
      */}
      <span className="fz-14 color-lightning">{t('txt-export-pdf')}</span>
    </div>
  </div>
);

export default translate('translations')(PrintButton);
